<template>
  <div>
    <!--Header-->
    <div class="header bg-success pt-7 pb-4">
      <b-container fluid>
        <div class="header-body">
          <b-row align-v="center">
            <b-col lg="7" class="">
              <div class="pr-6">
                <h1 class="display-3 text-white font-weight-bold mb-0">
                  Azure DevOps Integration
                </h1>
                <h2 class="display-4 text-white font-weight-500">
                  Zendesk, Freshdesk, Freshservice
                  <em class="text-primary">(including Change Management)</em>, monday
                  Azure DevOps Integration.
                </h2>
                <p class="text-white mt-4">
                  Azure DevOps is an easy and quick integration between Zendesk
                  - DevOps. Create, Link, Notify, Search work items and fetch
                  Reporting.
                </p>
                <div class="text-white mt-2 font-weight-bold mt-4">
                  <strong class="display-4 text-primary font-weight-bold mb-0">Start a free trial now,
                    <em>No credit card required</em></strong><br />
                  <router-link to="/apps/zendesk-azure-devops-integration" class="btn btn-neutral text-primary my-2">
                    Zendesk Azure DevOps</router-link>
                  <router-link to="/apps/freshdesk-azure-devops-integration" class="btn btn-neutral text-primary my-2">
                    Freshdesk Azure DevOps</router-link>
                  <router-link to="/apps/freshservice-azure-devops-integration"
                    class="btn btn-neutral text-primary my-2">Freshservice Azure DevOps</router-link>
                  <router-link to="/apps/monday-azure-devops-integration"
                    class="btn btn-neutral text-primary my-2">monday Azure DevOps</router-link>
                </div>
                <p class="text-white mt-4">
                  Azure DevOps integrates your work items. Create bugs,
                  features, or custom work items. Use area paths, iteration,
                  priority, severity. Azure DevOps integrates your work items
                  and your own custom fields. link existing bugs, features, or
                  custom work items. Notify workitems. Azure DevOps integration
                  allows you to sync your comments, status, system fields and
                  custom fields in both directions based on your needs.
                </p>
                <div class="mt-1 float-right">
                  <a href="mailto:support@devopsintegration.io" class="btn btn-neutral text-primary my-2">Purchase App
                    Licence Now</a>
                </div>
                <div class="clearfix"></div>
                <h2 class="display-4 text-primary font-weight-500">
                  Freshservice Change Management DevOps Integration.
                </h2>
                <p class="text-white mt-2">
                  <strong class="text-white">Freshservice Change Request Integration Support</strong>
                  App offers simple integration between Freshservice Change
                  Request and Azure DevOps. Using this app, support agents can
                  create, link, and notify Azure DevOps work items with
                  Freshservice Changes.
                  <router-link to="/apps/freshservice-azure-devops-integration"
                    class="btn btn-neutral btn-sm text-warning my-2" title="Freshdesk Azure DevOps Integration">Learn
                    More</router-link>
                </p>
                <div class="clearfix"></div>
                <p class="text-white mt-3">
                  Zendesk-Azure DevOps app allows the support agents to create
                  Azure DevOps work items from Zendesk apps form. Zendesk-Azure
                  DevOps app also allows support agents to link existing Zendesk
                  tickets to an existing Azure DevOps work items. In addition,
                  Zendesk-Azure DevOps app allows support agents to help notify
                  the Azure DevOps team, by sending comments from Zendesk
                  support.
                </p>
              </div>
            </b-col>
            <b-col lg="5">
              <b-row class="pt-5">
                <b-col md="6">
                  <b-card no-body>
                    <b-card-body>
                      <div class="icon icon-shape bg-gradient-warning text-white rounded-circle shadow mb-4">
                        <i class="fa fa-info"></i>
                      </div>
                      <h5 class="h3">Customization Support</h5>
                      <p>
                        Azure DevOps Integration app is totally flexible to meet
                        your needs. If you have any customization requirements.
                        Please contact at support with your requirements and
                        they will help you to meet your requirements!
                      </p>
                    </b-card-body>
                  </b-card>
                  <b-card no-body>
                    <b-card-body>
                      <div class="icon icon-shape bg-gradient-info text-white rounded-circle shadow mb-4">
                        <i class="fa fa-question"></i>
                      </div>
                      <h5 class="h3">24*7 Support</h5>
                      <p>
                        We have very good documentation and this integration is
                        very easy to use. if you still have any questions or you
                        need any assitance with the integration. We provide 24*7
                        SLA Support.
                      </p>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col md="6" class="pt-lg-5 pt-4">
                  <b-card no-body>
                    <b-card-body class="mb-4">
                      <div class="icon icon-shape bg-gradient-success text-white rounded-circle shadow mb-4">
                        <i class="fa fa-sync"></i>
                      </div>
                      <h5 class="h3">Bi-Directional Syncing</h5>
                      <p>
                        In the Zendesk-Azure DevOps app Enable Syncing lets you
                        enable the syncing of data from Zendesk to Azure DevOps
                        and Azure DevOps to Zendesk.
                      </p>
                    </b-card-body>
                  </b-card>
                  <b-card no-body class="mb-4">
                    <b-card-body>
                      <div class="icon icon-shape bg-gradient-red text-white rounded-circle shadow mb-4">
                        <i class="ni ni-active-40"></i>
                      </div>
                      <h5 class="h3">On-Premise and Cloud Support</h5>
                      <p>
                        Our integration supports both On-Premise and Cloud
                        servers.
                      </p>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100" style="display:none">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <section class="py-2 pl-5 pr-5 pb-9 bg-default">
      <b-row class="justify-content-center text-left">
        <b-col md="12">
          <h2 class="display-3 text-white">
            Zendesk - Azure DevOps Integration
          </h2>
          <p class="lead text-white">
            Zendesk-Azure DevOps Integration App simple integration between
            Zendesk and Azure DevOps. Support agents using this app can Create,
            link, notify Azure DevOps work items. Zendesk - Azure DevOps
            integration app allows the agents to create Azure DevOps work items
            from Zendesk ticket very easily. Zendesk-Azure DevOps app also
            allows support agents to link existing Zendesk tickets to an
            existing Azure DevOps work items. In addition, Zendesk-Azure DevOps
            app allows support agents to help notify the Azure DevOps team, by
            sending comments from Zendesk support.
          </p>
          <p class="lead text-white">
            Azure DevOps Integration app is totally flexible to meet your needs.
            If you have any customization requirements. Please contact at
            support with your requirements and they will help you to meet your
            requirements! We bring Zendesk - Azure DevOps integration app closer
            to your business model requirements!
          </p>

          <p class="lead text-center">
            <router-link to="/apps/zendesk-azure-devops-integration" class="btn btn-primary my-2">Explore More about
              this</router-link>
          </p>
        </b-col>
      </b-row>
    </section>
    <section class="section section-lg pt-lg-0 mt--7">
      <b-container>
        <b-row class="justify-content-center">
          <b-col lg="12">
            <b-row>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-primary text-white rounded-circle mb-4">
                      <i class="ni ni-check-bold"></i>
                    </div>
                    <h4 class="h3 text-primary text-uppercase">
                      Azure DevOps Integration
                    </h4>
                    <p class="description mt-3">
                      DevOpsIntegration.IO provides integration between several
                      Customer Support portals and Azure DevOps portal. We
                      provide integration between Zendesk - Azure DevOps,
                      Freshdesk - Azure DevOps, Freshservice - Azure DevOps etc.
                    </p>
                    <div>
                      <b-badge pill variant="primary">Zendesk</b-badge>
                      <b-badge pill variant="primary">Freshdesk</b-badge>
                      <b-badge pill variant="primary">Freshservice</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-success text-white rounded-circle mb-4">
                      <i class="ni ni-istanbul"></i>
                    </div>
                    <h4 class="h3 text-success text-uppercase">
                      Customization Support
                    </h4>
                    <p class="description mt-3">
                      We also support customization based on customer request
                      and tailored to your needs! We bring Azure DevOps closer
                      to your business requirements!
                      <a href="mailto:support@devopsintegration.io" target="_blank">support@devopsintegration.io</a>
                      Email us your requirements.
                    </p>
                    <div>
                      <b-badge pill variant="success">SLA Support</b-badge>
                      <b-badge pill variant="success">Customizable</b-badge>
                      <b-badge pill variant="success">Simple to use</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-warning text-white rounded-circle mb-4">
                      <i class="ni ni-planet"></i>
                    </div>
                    <h4 class="h3 text-warning text-uppercase">
                      Full Sass support
                    </h4>
                    <p class="description mt-3">
                      We provide 24*7 full support to our customers. Contact Us
                      for any kind of support you need to integrate your Custom
                      Support like Zendesk, Freshdesk, Freshservice, monday with Azure
                      DevOps.
                    </p>
                    <div>
                      <b-badge pill variant="warning">Easy Integration</b-badge>
                      <b-badge pill variant="warning">Awesome Design</b-badge>
                      <b-badge pill variant="warning">Full Support</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="py-2 pl-5 pr-5 pb-9 bg-default">
      <b-row class="justify-content-center text-left">
        <b-col md="12">
          <h2 class="display-3 text-white">
            Freshdesk - Azure DevOps Integration
          </h2>
          <p class="lead text-white">
            Our Best Integration Services Make You Feel Good
          </p>
          <p class="lead text-white">
            Freshdesk - Azure DevOps Integration App offers simple integration
            between Freshdesk and Azure DevOps. Using this app, support agents
            can create, link, and notify Azure DevOps work items. You can
            collaborate with your support team and developers in one place.
          </p>
          <p class="lead text-white">
            Freshdesk - Azure DevOps integration app allows the agents to create
            Azure DevOps work items from Freshdesk ticket very easily. The
            Freshdesk-Azure DevOps app also allows support agents to link
            existing Freshdesk tickets to existing Azure DevOps work items. In
            addition, the Freshdesk-Azure DevOps app allows support agents to
            help notify the Azure DevOps team by sending comments from Freshdesk
            support. Freshdesk - Azure DevOps Integration App offers simple
            integration between Freshdesk and Azure DevOps. Using this app,
            support agents can create, link, and notify Azure DevOps work items.
            You can collaborate with your support team and developers in one
            place.
          </p>
          <p class="lead text-white">
            We also support customization based on customer requests and
            tailored to your needs! We bring Azure DevOps closer to your
            business requirements!
          </p>
          <p class="lead text-center">
            <router-link to="/apps/freshdesk-azure-devops-integration" class="btn btn-primary my-2">Explore More about
              this</router-link>
          </p>
        </b-col>
      </b-row>
    </section>
    <section class="section section-lg pt-lg-0 mt--7">
      <b-container>
        <b-row class="justify-content-center">
          <b-col lg="12">
            <b-row>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-primary text-white rounded-circle mb-4">
                      <i class="ni ni-check-bold"></i>
                    </div>
                    <h4 class="h3 text-primary text-uppercase">Fast Service</h4>
                    <p class="description mt-3">
                      We are running on Microsoft Azure for faster processing.
                    </p>
                    <div>
                      <b-badge pill variant="primary">Freshdesk Azure DevOps Integration</b-badge>
                      <b-badge pill variant="primary">Fast Response</b-badge>
                      <b-badge pill variant="primary">Instant Syncing</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-success text-white rounded-circle mb-4">
                      <i class="ni ni-istanbul"></i>
                    </div>
                    <h4 class="h3 text-success text-uppercase">Time Saving</h4>
                    <p class="description mt-3">
                      Freshdesk - Azure DevOps app helps you save your time by
                      quickly processing your data.
                    </p>
                    <div>
                      <b-badge pill variant="success">Customize View</b-badge>
                      <b-badge pill variant="success">Auto Fill Fields</b-badge>
                      <b-badge pill variant="success">Auto Creation</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-warning text-white rounded-circle mb-4">
                      <i class="ni ni-planet"></i>
                    </div>
                    <h4 class="h3 text-warning text-uppercase">
                      Business Planning
                    </h4>
                    <p class="description mt-3">
                      We can customize the Azure DevOps integration based on
                      your Business modal.
                    </p>
                    <div>
                      <b-badge pill variant="warning">Customize Mapping</b-badge>
                      <b-badge pill variant="warning">Fields Syncing</b-badge>
                      <b-badge pill variant="warning">Mapping of Fields</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="py-2 pl-5 pr-5 pb-9 bg-default">
      <b-row class="justify-content-center text-left">
        <b-col md="12">
          <h2 class="display-3 text-white">
            Freshservice - Azure DevOps Integration
          </h2>
          <p class="lead text-white">
            Freshservice-Azure DevOps Integration App simple integration between
            Freshservice and Azure DevOps. Support agents using this app can
            Create, link, notify Azure DevOps work items. You can Collaborate
            your support team and developers at one place. \n\n Zendesk-Azure
            DevOps app allows the support agents to create Azure DevOps work
            items from Freshservice apps form. Freshservice-Azure DevOps app
            also allows support agents to link existing Zendesk tickets to an
            existing Azure DevOps work items. In addition, Freshservice-Azure
            DevOps app allows support agents to help notify the Azure DevOps
            team, by sending comments from Freshservice support.
          </p>
          <p class="lead text-white">
            We provides integration between several Customer Support portals and
            Azure DevOps portal. We provide integration between Zendesk - Azure
            DevOps, Freshdesk - Azure DevOps, Freshservice - Azure DevOps etc.
            Azure DevOps integrates your work items. Create bugs, features, or
            custom work items. Use area paths, iteration, priority, severity.
            Azure DevOps integrates your work items and your own custom fields.
            link existing bugs, features, or custom work items. Notify
            workitems.
          </p>
          <p class="lead text-white">
            Azure DevOps integration allows you to sync your comments, status,
            system fields and custom fields in both directions based on your
            needs. We also support customization based on customer requests and
            tailored to your needs! We bring Azure DevOps closer to your
            business requirements!
          </p>
          <p class="lead text-center">
            <router-link to="/apps/freshservice-azure-devops-integration" class="btn btn-primary my-2">Explore More
              about this</router-link>
          </p>
        </b-col>
      </b-row>
    </section>
    <section class="section section-lg pt-lg-0 mt--7">
      <b-container>
        <b-row class="justify-content-center">
          <b-col lg="12">
            <b-row>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-primary text-white rounded-circle mb-4">
                      <i class="ni ni-check-bold"></i>
                    </div>
                    <h4 class="h3 text-primary text-uppercase">Fast Service</h4>
                    <p class="description mt-3">
                      We are running on Microsoft Azure for faster processing.
                    </p>
                    <div>
                      <b-badge pill variant="primary">Freshdesk Azure DevOps Integration</b-badge>
                      <b-badge pill variant="primary">Fast Response</b-badge>
                      <b-badge pill variant="primary">Instant Syncing</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-success text-white rounded-circle mb-4">
                      <i class="ni ni-istanbul"></i>
                    </div>
                    <h4 class="h3 text-success text-uppercase">Time Saving</h4>
                    <p class="description mt-3">
                      Freshdesk - Azure DevOps app helps you save your time by
                      quickly processing your data.
                    </p>
                    <div>
                      <b-badge pill variant="success">Customize View</b-badge>
                      <b-badge pill variant="success">Auto Fill Fields</b-badge>
                      <b-badge pill variant="success">Auto Creation</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-warning text-white rounded-circle mb-4">
                      <i class="ni ni-planet"></i>
                    </div>
                    <h4 class="h3 text-warning text-uppercase">
                      Business Planning
                    </h4>
                    <p class="description mt-3">
                      We can customize the Azure DevOps integration based on
                      your Business modal.
                    </p>
                    <div>
                      <b-badge pill variant="warning">Enhanced Collaboration</b-badge>
                      <b-badge pill variant="warning">Fields Syncing</b-badge>
                      <b-badge pill variant="warning">Mapping of Fields</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <!--monday sections starts here-->

    <section class="py-2 pl-5 pr-5 pb-9 bg-default">
      <b-row class="justify-content-center text-left">
        <b-col md="12">
          <h2 class="display-3 text-white">
            Seamless monday.com and Azure DevOps Integration
          </h2>
          <p class="lead text-white">
            Our powerful integration between monday.com and Azure DevOps ensures that your teams stay connected and
            collaborate efficiently, no matter the platform they use.
          </p>
          <h3 class="display-4 text-white">Key Features:</h3>
          <ul class="text-white">
            <li>
              <h3 class="display-5 text-white">Bi-Directional Sync for Comments:</h3>
              Maintain seamless communication across platforms with comments synced in real time. Whether a comment is
              added in monday.com or Azure DevOps, it is instantly reflected on the other platform.
              Attachment Synchronization
            </li>
            <li>
              <h3 class="display-5 text-white">Attachment Synchronization:</h3>
              Share critical files effortlessly. Attachments added in monday.com or Azure DevOps are automatically
              synced
              to the other platform, ensuring all team members have access to the latest documents and resources.
            </li>
            <li>
              <h3 class="display-5 text-white">Field Mapping and Updates:</h3>
              Synchronize key data fields such as status, priority, due dates, and custom fields. Changes made in one
              platform are immediately mirrored in the other, keeping your workflows up-to-date.
            </li>
          </ul>

          <h3 class="display-4 text-white">Why Choose This Integration?:</h3>
          <ul class="text-white">
            <li>
              <h3 class="display-5 text-white">Enhanced Collaboration:</h3>
              Break down silos between project management and development teams.
            </li>
            <li>
              <h3 class="display-5 text-white">Improved Productivity:</h3>
              Minimize manual updates and ensure data consistency across platforms.
            </li>
            <li>
              <h3 class="display-5 text-white">Customizable Workflows:</h3>
              Tailor the integration to meet your specific project requirements.
            </li>
          </ul>

          <h3 class="display-4 text-white">Use Cases:</h3>
          <ul class="text-white">
            <li>
              <h3 class="display-5 text-white">Project Tracking:</h3>
              Align tasks and statuses between monday.com and Azure DevOps for better visibility.
            </li>
            <li>
              <h3 class="display-5 text-white">Agile Development:</h3>
              Enable smoother sprints by syncing work items and boards across platforms.
            </li>
            <li>
              <h3 class="display-5 text-white">Cross-Functional Collaboration:</h3>
              Keep stakeholders on both systems informed with synchronized updates.
            </li>
          </ul>
          <p class="lead text-white">
            Set up this integration and let your teams focus on delivering outstanding results without worrying about
            managing tools.
          </p>

          <p class="lead text-center">
            <router-link to="/apps/monday-azure-devops-integration" class="btn btn-primary my-2">Explore More
              about this</router-link>
          </p>
        </b-col>
      </b-row>
    </section>
    <section class="section section-lg pt-lg-0 mt--7">
      <b-container>
        <b-row class="justify-content-center">
          <b-col lg="12">
            <b-row>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-primary text-white rounded-circle mb-4">
                      <i class="ni ni-check-bold"></i>
                    </div>
                    <h4 class="h3 text-primary text-uppercase">
                      Bi-Directional Sync
                    </h4>
                    <p class="description mt-3">
                      Stay aligned with real-time synchronization of comments across both platforms. Keep your workflows
                      consistent by syncing key fields like statuses, priorities, and custom data. Share files.<br>
                      seamlessly with automatic attachment syncing.
                    </p>
                    <div>
                      <b-badge pill variant="success">Comments</b-badge>
                      <b-badge pill variant="success">Attachments</b-badge>
                      <b-badge pill variant="success">Status Syncing</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-success text-white rounded-circle mb-4">
                      <i class="ni ni-istanbul"></i>
                    </div>
                    <h4 class="h3 text-success text-uppercase">
                      Enhanced Collaboration
                    </h4>
                    <p class="description mt-3">
                      Break down silos between teams with real-time synchronization of comments, attachments, and
                      fields. Whether using monday.com or Azure DevOps, everyone stays aligned, enabling seamless
                      communication and a unified workflow.

                    </p>
                    <div>
                      <b-badge pill variant="primary">real-time sync</b-badge>
                      <b-badge pill variant="primary">Unlimited WorkItems</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-warning text-white rounded-circle mb-4">
                      <i class="ni ni-planet"></i>
                    </div>
                    <h4 class="h3 text-warning text-uppercase">
                      Project Tracking
                    </h4>
                    <p class="description mt-3">
                      Keep tasks, statuses, and updates aligned across monday.com and Azure DevOps. With real-time
                      synchronization, ensure better visibility, streamlined workflows, and efficient project management
                      for all teams.
                    </p>
                    <div>
                      <b-badge pill variant="warning">Better Visibility</b-badge>
                      <b-badge pill variant="warning">Streamlined Workflows</b-badge>
                      <b-badge pill variant="warning">Full Support</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <!--monday section ends here-->

    <section class="py-4" style="display:block">
      <b-container fluid>
        <b-row align-v="center" class="row-grid">
          <b-col md="6" class="order-md-2">
            <div id="video" fluid>
              <iframe width="560" height="315" title="Zendesk Azure DevOps Integration Pro" fluid
                src="https://www.youtube.com/embed/9BlXqqJDZkc?autoplay=1&mute=1&autohide=0&controls=0&modestbranding=1&rel=0&showinfo=0&disablekb=1&loop=1"
                frameborder="0" scrolling="no" allowfullscreen></iframe>
            </div>
            <!-- <b-img src="img/theme/landing-1.png" fluid /> -->
          </b-col>
          <b-col md="6" class="order-md-1">
            <div class="pr-md-5">
              <h1>
                Connect your apps and automate workflows with Awesome features
              </h1>
              <p>
                Easy automation for busy people. Azure DevOps Integration moves
                info between your web apps automatically, so you can focus on
                your most important work.
              </p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <b-badge pill variant="success" class="badge-circle mr-3">
                        <i class="ni ni-settings-gear-65"></i>
                      </b-badge>
                    </div>
                    <div>
                      <h4 class="mb-0">
                        Integrate
                        <small>Link your web apps with a few clicks, so they can
                          share data</small>
                      </h4>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <b-badge pill variant="success" class="badge-circle mr-3">
                        <i class="ni ni-html5"></i>
                      </b-badge>
                    </div>
                    <div>
                      <h4 class="mb-0">
                        Automate
                        <small>Pass info between your apps with workflows</small>
                      </h4>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <b-badge pill variant="success" class="badge-circle mr-3">
                        <i class="ni ni-satisfied"></i>
                      </b-badge>
                    </div>
                    <div>
                      <h4 class="mb-0">
                        Innovate
                        <small>Build processes faster and get more done—no code
                          required</small>
                      </h4>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <b-badge pill variant="success" class="badge-circle mr-3">
                        <i class="ni ni-satisfied"></i>
                      </b-badge>
                    </div>
                    <div>
                      <h4 class="mb-0">Super friendly support team</h4>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="py-4" style="display:block">
      <b-container fluid>
        <b-row align-v="center" class="row-grid">
          <b-col md="6">
            <b-img src="assets/img/apps/zendesk/App.png" fluid />
          </b-col>
          <b-col md="6">
            <div class="pr-md-5">
              <h1>Two way comment and status synchronization</h1>
              <p>
                Anyone can build workflows with a few clicks Our editor was made
                for do-it-yourself automation. Set up syncing setup help
                articles or contact
                <a href="mailto:support@devopsintegration.io" target="_blank"
                  class="text-primary">support@devopsintegration.io</a>.
              </p>
              <a href="https://support.devopsintegration.io/support/solutions/82000195912" target="_blank"
                class="btn base-button btn-neutral font-weight-bold text-primary mt-5">See all help articles</a>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="py-6" style="display:block">
      <b-container fluid>
        <b-row align-v="center" class="row-grid">
          <b-col md="6" class="order-md-2">
            <b-img src="/assets/img/apps/zendesk/SearchWorkItem.png" fluid />
          </b-col>
          <b-col md="6" class="col-md-6">
            <div class="pr-md-5">
              <h1>Fully Customizable and Customization Support</h1>
              <p>
                We also support customization based on customer request and
                tailored to your needs! We bring Azure DevOps closer to your
                business requirements!
                <a href="mailto:support@devopsintegration.io" target="_blank"
                  class="text-primary">support@devopsintegration.io</a>
                Email us your requirements.
              </p>
              <router-link to="/apps" class="font-weight-bold text-info mt-5">Explore Apps</router-link>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="py-5 section-nucleo-icons bg-white overflow-hidden" style="display:block">
      <b-container fluid>
        <b-row class="justify-content-center">
          <b-col lg="8" class="text-center">
            <h2 class="display-3">Azure DevOps Integration Features</h2>
            <p class="lead">
              Azure DevOps integrates your work items. Create bugs, features, or
              custom work items. Use area paths, iteration, priority, severity.
              Azure DevOps integrates your work items and your own custom
              fields. link existing bugs, features, or custom work items. Notify
              workitems. Azure DevOps integration allows you to sync your
              comments, status, system fields and custom fields in both
              directions based on your needs.
            </p>
            <div class="btn-wrapper">
              <a href="https://support.devopsintegration.io/support/solutions/82000195912" target="_blank"
                class="btn btn-primary">View all articles</a>
              <a href="mailto:support@devopsintegration.io" target="_blank" class="btn btn-default mt-3 mt-md-0">Contact
                Us</a>
            </div>
          </b-col>
        </b-row>
        <div class="blur--hover">
          <a href="https://www.creative-tim.com/learning-lab/bootstrap-vue/icons/argon-dashboard">
            <div class="icons-container blur-item mt-5">
              <!-- Center -->
              <i class="icon fa fa-sync-alt"></i>
              <!-- Right 1 -->
              <i class="icon icon-sm fa fa-plus"></i>
              <i class="icon icon-sm fa fa-link"></i>
              <i class="icon icon-sm fa fa-comment"></i>
              <!-- Right 2 -->
              <i class="icon fa fa-comment-alt"></i>
              <i class="icon fa fa-question"></i>
              <i class="icon ni ni-credit-card"></i>
              <!-- Left 1 -->
              <i class="icon icon-sm fa fa-fast-forward"></i>
              <i class="icon icon-sm fa fa-building"></i>
              <i class="icon icon-sm ni ni-button-play"></i>
              <!-- Left 2 -->
              <i class="icon ni ni-calendar-grid-58"></i>
              <i class="icon ni ni-camera-compact"></i>
              <i class="icon ni ni-chart-bar-32"></i>
            </div>
            <span class="blur-hidden h5 text-success">Eplore all the features of Azure DevOps Integration</span>
          </a>
        </div>
      </b-container>
    </section>
    <section class="py-5" style="display:block">
      <b-container fluid>
        <b-row class="row-grid justify-content-center">
          <b-col lg="8" class="text-center">
            <h2 class="display-3">
              Do you love this
              <span class="text-success">Azure DevOps Integration ?</span>
            </h2>
            <p class="lead">
              Please review us for the Azure DevOps Integration cause if you do,
              it can be helpful for other's too! Hit the button below to
              navigate to post the review!
            </p>
            <div class="btn-wrapper">
              <a href="/apps/support/azure-devops-integration/?q=mkp_azure" class="btn btn-neutral" aria-pressed="true"
                target="_blank"><span class="btn-inner--text">Get FREE version</span></a>
              <a href="mailto:support@devopsintegration.io" class="btn btn-success btn-icon mb-3 mb-sm-0">
                <span class="btn-inner--icon"><i class="ni ni-basket"></i></span>
                <span class="btn-inner--text">Purchase now</span>
                <b-badge size="md" pill variant="danger" class="badge-floating border-white">$59</b-badge>
              </a>
            </div>
            <div class="text-center">
              <h4 class="display-4 mb-5 mt-5">Available on these</h4>
              <b-row class="justify-content-center">
                <b-col md="2" cols="4" class="my-2">
                  <el-tooltip placement="top" content="Zendesk Azure DevOps Integration">
                    <a href="/apps/support/azure-devops-integration/?q=mkp_azure" target="_blank">
                      <b-img
                        src="https://assets.website-files.com/5a0242c3d47dd70001e5b2e9/5cac60e3f8d44d025118d7fa_medium.svg"
                        fluid rounded="circle" class="shadow shadow-lg--hover" />
                    </a>
                  </el-tooltip>
                </b-col>
                <b-col md="2" cols="4" class="my-2 pt-3">
                  <el-tooltip placement="top" content="Freshdesk Azure DevOps Integration">
                    <a href="https://www.freshworks.com/apps/freshdesk_azure_devops_integration/" target="_blank">
                      <b-img src="https://freshdesk.com/static-assets/images/common/company/logos/logo-fworks-black.svg"
                        fluid rounded="circle" class="shadow shadow-lg--hover" />
                    </a>
                  </el-tooltip>
                </b-col>
                <b-col md="2" cols="4" class="my-2 pt-3">
                  <el-tooltip placement="top" content="Freshservice Azure DevOps Integration">
                    <a href="https://www.freshworks.com/apps/freshservice_azure_devops_integration/" target="_blank">
                      <b-img src="https://freshdesk.com/static-assets/images/common/company/logos/logo-fworks-black.svg"
                        fluid rounded="circle" />
                    </a>
                  </el-tooltip>
                </b-col>
                <b-col md="2" cols="4" class="my-2 pt-3">
                  <el-tooltip placement="top" content="monday Azure DevOps Integration">
                    <a href="https://monday.com/marketplace/listing/10000746/azure-devops-integration-bisync"
                      target="_blank">
                      <b-img src="https://monday.com/p/wp-content/uploads/2023/03/Logo-monday.com-2.png" fluid
                        rounded="circle" />
                    </a>
                  </el-tooltip>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="py-5 section-nucleo-icons bg-white overflow-hidden" style="display:block">
      <b-container fluid>
        <b-row class="row-grid justify-content-center">
          <b-col lg="8" class="text-center">
            <h2 class="display-3">
              Azure DevOps Integration
              <span class="text-success">makes you happier</span>
            </h2>
            <p class="lead">
              Huge number of people rely on Azure DevOps Integration to take
              care of their tedious tasks.
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col lg="12">
            <h2 class="text-center text-info display-2">Customer Review's</h2>
            <b-row>
              <b-col lg="3">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-3">
                    <div class="icon icon-shape bg-gradient-info text-white rounded-circle mb-2">
                      <i class="fa fa-user"></i>
                    </div>
                    &nbsp;
                    <strong class="h3 text-primary float-right text-uppercase">Dean Sierra</strong>
                    <p class="description review-desc mt-1">
                      "If we didn't get these syncing of comments through ADO
                      Integration, we'd miss important information on how
                      patient funding is going. It's saved us so much time."
                    </p>
                    <h4 class="h3 text-success float-right text-uppercase">
                      <em>Data House</em>
                    </h4>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="3">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-3">
                    <div class="icon icon-shape cust-icon text-white rounded-circle mb-2" style="padding:unset">
                      <!--<img src="https://sisorgcloudhelp.zendesk.com/system/photos/1260885627110/IMG-20210822-WA0006.jpg"
                        alt="Zendesk Azure DevOps Integration" />-->
                    </div>
                    &nbsp;
                    <strong class="h3 text-primary float-right text-uppercase">Javier Nardi</strong>
                    <p class="description review-desc mt-1">
                      They answered my questions and the integration is really
                      very comfortable, reliable and the support service is
                      excellent. Highly recommended.
                    </p>
                    <h4 class="h3 text-success float-right text-uppercase">
                      <em>Sisorg Cloud Solutions</em>
                    </h4>
                  </b-card-body>
                </b-card>
              </b-col>

              <b-col lg="3">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-3">
                    <div class="icon icon-shape cust-icon text-white rounded-circle mb-2" style="padding:unset">
                      <img src="https://thebigwordtechteam.zendesk.com/system/photos/360527160577/Burnie_New_Avatar.png"
                        alt="Zendesk Azure DevOps Integration" />
                    </div>
                    &nbsp;
                    <strong class="h3 text-primary float-right text-uppercase">Martin Burnside</strong>
                    <p class="description review-desc mt-1">
                      Installed this a couple of months ago now. We are quite
                      complex with multiple brands & DevOps projects but the
                      initial setup help was excellent & ongoing support is now
                      minimum. This piece of integration saves a lot of rekeying
                      of data, so I don't mind paying the small monthly fees, as
                      the developer needs to earn a living.
                    </p>
                    <h4 class="h3 text-success float-right text-uppercase">
                      <em>thebigword</em>
                    </h4>
                  </b-card-body>
                </b-card>
              </b-col>

              <b-col lg="3">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-3">
                    <div class="icon icon-shape bg-gradient-info text-white rounded-circle mb-2">
                      <i class="fa fa-user"></i>
                    </div>
                    &nbsp;
                    <strong class="h3 text-primary float-right text-uppercase">Nick</strong>
                    <p class="description review-desc mt-1">
                      It helped us a lot in managing our Customers. Using this
                      integration the Development Team was able to be quickly
                      see and address the customers’ issues. Their support was
                      always fast and reliable.
                    </p>
                    <h4 class="h3 text-success float-right text-uppercase">
                      <em>Infinent</em>
                    </h4>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<style scoped>
.rounded-circle img {
  border-radius: 50%;
}
.rounded-circle img {
  width: 3.6rem;
}
.cust-icon {
  width: 3.7rem;
  height: 3.7rem;
}
.review-desc {
  min-height: 185px;
}
</style>
<script>
import { Tooltip } from "element-ui";
export default {
  name: "home-page",
  components: {
    [Tooltip.name]: Tooltip
  }
};
</script>
